import { Injectable } from '@angular/core';
import { FormattedPrice } from '@libs/shop/models';

@Injectable({
  providedIn: 'root',
})
export class PricesFormatter {

  public formatPrice(value: number, alwaysPositiveNumber: boolean = false): FormattedPrice {
    if (alwaysPositiveNumber) {
      value = Math.abs(value);
    }

    // Example: value = 8799
    const decimalValue: number = value / 1000; // 8.799
    const decimalValueRounded: number = Math.round(decimalValue * 100) / 100; // 8.8
    const formattedValueHundredthsRounded: string = decimalValueRounded.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }); // "8,80"
    const formattedValueThousandths: string = decimalValue.toLocaleString('de-DE', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }); // "8,799"

    return {
      priceRoundedToHundredth: formattedValueHundredthsRounded, // "8,80"
      priceSlicedToHundredth: formattedValueThousandths.slice(0, -1), // "8,79"
      thousandsPlace: formattedValueThousandths.slice(-1), // "9"
    };
  }
}
